export type FeaturedVideoCardProps = {
	thumbnailUrl: string;
	thumbnailAlt: string;
	videoUrl: string;
	videoTitle: string;
	text: string;
};

const FeaturedVideoCard = ({ videoUrl, videoTitle, text }: FeaturedVideoCardProps) => {
	return (
		<div className="relative max-h-96 overflow-hidden rounded bg-white">
			<div className="max-h-64">
				<iframe
					src={videoUrl}
					title={videoTitle}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen
					className="aspect-video h-full w-full"
					suppressHydrationWarning
				/>
			</div>

			<div className="p-3">
				<div>
					<div className="mb-4 flex w-fit items-center justify-center gap-x-1 whitespace-nowrap rounded-md border p-1 text-xs">
						<span className="h-1.5 w-1.5 rounded-full bg-red-500" />
						<span>1.48K subscribers</span>
					</div>
				</div>

				<h5 className="font-medium">{text}</h5>
			</div>
		</div>
	);
};

export default FeaturedVideoCard;
